import { __awaiter, __generator } from "tslib";
import { registerFormTracking } from './FormTracking';
import { version } from './constants';
export var ddFormTracking = function (options) {
    return {
        name: 'FormTracking',
        type: 'utility',
        version: version,
        isLoaded: function () { return true; },
        load: function (ctx, analytics) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, registerFormTracking(analytics, options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, ctx];
                }
            });
        }); },
    };
};
//# sourceMappingURL=index.js.map